<!-- Responsibility: Implement journal feed behavior for the ui/components surface.
Scope: Owns ui/components concerns only; cross-surface orchestration is excluded. -->
<journal-feed>
    <div class="journal-feed" ref="feed" onscroll={ onScroll }>
        <p if={ !getEntries(gameStore.state).length } class="journal-empty" role="note">{ emptyText() }</p>
        <div each={ entry in getEntries(gameStore.state) } class="journal-entry-row">
            <div if={ entry.temporalDivider } class="journal-temporal-divider">
                <span>{ entry.temporalLabel }</span>
            </div>
            <journal-entry entry={ entry }></journal-entry>
        </div>
    </div>
    <button
        if={ state.showJumpBtn }
        type="button"
        class="jump-btn visible"
        aria-label="Scroll to latest entry"
        onclick={ jumpToPresent }
    >Latest ↓</button>

    <script>
        import {dispatcher} from '../../app-states.js'
        import {TOPICS} from "@anyquest/shared-core"
        import * as gameStore from '../../game-store.js'
        import JournalEntry from './journal-entry.riot'

        export default {
            components: {
                JournalEntry,
            },

            gameStore,

            state: {
                showJumpBtn: false,
            },

            onMounted() {
                this.handles = [
                    dispatcher.on(TOPICS.game.loaded,         () => { this.update() }),
                    dispatcher.on(TOPICS.game.started,        () => { this.update() }),
                    dispatcher.on(TOPICS.game.actionComplete, () => { this.update() }),
                    dispatcher.on(TOPICS.game.actionUpdate,   () => { this.update() }),
                ]
            },

            onUnmounted() {
                this.handles?.forEach(h => dispatcher.off(h))
            },

            getEntries(gs) {
                if (!gs) return [];
                const entries = gs.history.map((entry, i) => ({
                    ...entry,
                    isLatest: i === gs.history.length - 1,
                    historyIndex: i,
                }));
                // In history-only mode, hide the active scene tail (shown in center pane).
                if (this.props.historyOnly) {
                    const rawTail = Number(this.props.excludeTailCount);
                    const tail = Number.isFinite(rawTail)
                        ? Math.max(0, Math.floor(rawTail))
                        : 1;
                    return this.decorateTemporalRuns(entries.slice(0, Math.max(0, entries.length - tail)));
                }
                return this.decorateTemporalRuns(entries);
            },

            emptyText() {
                if (this.props.historyOnly) {
                    return 'No field-log entries yet. Take an action to extend the chronicle.'
                }
                return 'No chronicle entries yet.'
            },

            decorateTemporalRuns(entries, minRun = 3) {
                const list = Array.isArray(entries) ? entries : []
                if (!list.length) return []
                const out = []
                let i = 0
                while (i < list.length) {
                    const location = String(list[i]?.location ?? '').trim().toLowerCase()
                    let j = i + 1
                    while (j < list.length) {
                        const nextLocation = String(list[j]?.location ?? '').trim().toLowerCase()
                        if (nextLocation !== location) break
                        j += 1
                    }
                    const runLength = j - i
                    for (let k = i; k < j; k += 1) {
                        const entry = { ...list[k], temporalDivider: false, temporalLabel: '' }
                        if (k === i && runLength >= minRun) {
                            const room = String(list[i]?.location ?? 'Unknown').trim() || 'Unknown'
                            const fromTime = String(list[i]?.time ?? '').trim()
                            const toTime = String(list[j - 1]?.time ?? '').trim()
                            const hasTimeRange = !!fromTime && !!toTime && fromTime !== toTime
                            const range = hasTimeRange ? `${fromTime} → ${toTime}` : (fromTime || toTime || '')
                            entry.temporalDivider = true
                            entry.temporalLabel = range
                                ? `${room} · ${runLength} moments · ${range}`
                                : `${room} · ${runLength} moments`
                        }
                        out.push(entry)
                    }
                    i = j
                }
                return out
            },

            onScroll(e) {
                if (this.scrollTimer) return
                this.scrollTimer = window.setTimeout(() => {
                    this.scrollTimer = 0
                    const feed = this.$('[ref="feed"]')
                    if (!feed) return
                    const nearBottom = feed.scrollHeight - feed.scrollTop - feed.clientHeight < 150
                    if (this.state.showJumpBtn === nearBottom) {
                        this.update({showJumpBtn: !nearBottom})
                    }
                }, 100)
            },

            jumpToPresent() {
                const feed = this.$('[ref="feed"]')
                feed?.scrollTo({top: feed.scrollHeight, behavior: 'smooth'})
            },
        }
    </script>
</journal-feed>
